(() => {
  const rootSelector = '[data-smaxup-gallery-root]';
  const videoSelector = '.smaxup-gallery__video';

  function play(video) {
    const promise = video.play();
    if (promise && typeof promise.catch === 'function') promise.catch(() => {});
  }

  function updateSoundButton(video) {
    const item = video.closest('.smaxup-gallery__item');
    const button = item && item.querySelector('[data-smaxup-gallery-sound]');
    if (!button) return;
    const muted = video.muted;
    button.setAttribute('aria-pressed', String(!muted));
    button.setAttribute('aria-label', muted ? 'Turn sound on' : 'Mute video');
  }

  function muteOtherVideos(activeVideo) {
    document.querySelectorAll(`${rootSelector} ${videoSelector}`).forEach((video) => {
      if (video === activeVideo) return;
      video.muted = true;
      updateSoundButton(video);
    });
  }

  function usesManualPlayback(video) {
    return video.closest('.smaxup-gallery__item')?.dataset.smaxupPlayback === 'click';
  }

  function usesAutoplay(video, galleryDefault) {
    const mode = video.closest('.smaxup-gallery__item')?.dataset.smaxupPlayback;
    return mode === 'autoplay' || (mode !== 'click' && galleryDefault);
  }

  function toggleSound(video) {
    const shouldUnmute = video.muted;
    muteOtherVideos(video);
    video.muted = !shouldUnmute;
    if (shouldUnmute && !usesManualPlayback(video)) play(video);
    updateSoundButton(video);
  }

  function init(root) {
    if (root.dataset.smaxupGalleryInitialized === 'true') return;
    root.dataset.smaxupGalleryInitialized = 'true';

    const videos = root.querySelectorAll(videoSelector);
    const autoplay = root.dataset.autoplay === 'true';
    const tapToUnmute = root.dataset.tapToUnmute === 'true';
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    videos.forEach((video) => {
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      updateSoundButton(video);

      const item = video.closest('.smaxup-gallery__item');
      const soundButton = item && item.querySelector('[data-smaxup-gallery-sound]');
      if (soundButton) {
        soundButton.addEventListener('click', () => toggleSound(video));
      }

      if (tapToUnmute && usesAutoplay(video, autoplay) && !video.controls) {
        video.addEventListener('click', () => toggleSound(video));
      }
    });

    if (!('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting && usesAutoplay(video, autoplay) && !reduceMotion) {
          play(video);
        } else {
          video.pause();
          video.muted = true;
          updateSoundButton(video);
        }
      });
    }, { rootMargin: '120px 0px', threshold: 0.05 });

    videos.forEach((video) => observer.observe(video));
  }

  function initAll(scope = document) {
    scope.querySelectorAll(rootSelector).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
